<script>
import { mapGetters } from 'vuex'
import Roles from '@/mixins/Roles'
import Filters from '@/mixins/Filters'
export default {
    name: 'OrderFilters',

    mixins: [Roles, Filters],

    data() {
        return {
            model: {
                order_status_id: null,
                customer_company_id: null,
                passenger_name: null,
                passenger_phone: null,
                passenger_email: null,
                passenger_number: null,
                luggage_number: null,
                carry_on_luggage_number: null,
                order_type_id: null,
                date_from: null,
                date_to: null,
                flightnumber: null,
                address: null,
                destination_address: null,
                provider_company_id: null,
                driver_user_id: null,
                car_id: null,
                packets: null,
                passenger_id: null,
                modifier_ids: {},
            },
        }
    },

    computed: {
        ...mapGetters({
            statuses: 'statuses',
            orderTypes: 'orderTypes',
            modifiers: 'orderModifiers',
            packets: 'packets',
        }),

        packetsExtended() {
            return [{id: -1, name: this.$t('ORDERS.ALL_NON_MINIBUS'), translated: this.$t('ORDERS.ALL_NON_MINIBUS')}, { id: -2, name: this.$t('ORDERS.ALL_MINIBUS'), translated: this.$t('ORDERS.ALL_NON_MINIBUS') }, ...this.packets.map((x) => { return {id: x.id, name: x.name, translated: x.name } })]
        },
    },
}
</script>

<template lang="pug">
div.overflow-scroll
    acrm-multi-select(
        v-if="hasRole('orderlist.filters.order_status_id')"
        v-model="model.order_status_id"
        :options="statuses"
        track-by="id"
        option-label="translated"
        multiple
        dark-label
        has-select-all
        :allow-empty="true"
        ) {{ $t('FILTER.STATUS') }}
    label.mt-4.mb-2.text-uppercase(v-if="hasRole('orderlist.filters.customer_company_id')") {{ $t('FILTER.ORDER')}}
    acrm-company-selector.mb-1(v-if="hasRole('orderlist.filters.customer_company_id')" v-model="model.customer_company_id" type="customer_own" first) {{ $t('FILTER.ORDER_COMPANY')}}

    label.mt-4.mb-2.text-uppercase {{ $t('FILTER.PASSENGER_DATA')}}
    acrm-input-line.mb-1(v-if="hasRole('orderlist.filters.passenger_name')" dark-label v-model="model.passenger_name") {{ $t('FILTER.NAME') }}
    acrm-input-phone.mb-1(v-if="hasRole('orderlist.filters.passenger_phone')" dark-label v-model="model.passenger_phone") {{ $t('FILTER.PHONE') }}
    acrm-input-line.mb-0(v-if="hasRole('orderlist.filters.passenger_email')" type="email" dark-label v-model="model.passenger_email") {{ $t('FILTER.EMAIL') }}
    acrm-input-line.mb-0(v-if="hasRole('orderlist.filters.passenger_id')" type="email" dark-label v-model="model.passenger_id") {{ $t('FILTER.PASSENGER_ID') }}

    label.mt-4.mb-2.text-uppercase {{ $t('FILTER.TRANS_DATA')}}
    acrm-input-line.mb-1(v-if="hasRole('orderlist.filters.passenger_number')" dark-label v-model="model.passenger_number") {{ $t('FILTER.PASSENGERS_NO') }}
    acrm-input-line.mb-1(v-if="hasRole('orderlist.filters.luggage_number')" dark-label v-model="model.luggage_number") {{ $t('FILTER.SUITCASES_NO') }}
    acrm-input-line.mb-1(v-if="hasRole('orderlist.filters.carry_on_luggage_number')" v-model="model.carry_on_luggage_number" dark-label) {{ $t('FILTER.HANDLUGGAGE_NO') }}
    acrm-multi-select.mb-0(
        v-if="hasRole('orderlist.filters.order_type_id')"
        :value="model.order_type_id"
        @input="model.order_type_id = $event.id"
        :options="orderTypes"
        track-by="id"
        option-label="translated"
        dark-label
    ) {{ $t('FILTER.TRANS_TYPE') }}

    label.mt-4.mb-2.text-uppercase {{ $t('ORDERS.TRANS_DATE')}}
    acrm-date-picker(v-model="model.date_from" local-time type="date" format="YY-MM-DD") {{ $t('ORDERS.TRANS_DATE_FROM') }}
    acrm-date-picker(v-model="model.date_to" local-time type="date" format="YY-MM-DD") {{ $t('ORDERS.TRANS_DATE_TO') }}

    acrm-input-line.mb-0(dark-label v-model="model.flightnumber" v-if="hasRole('orderlist.filters.flightnumber')") {{ $t('FILTER.FLIGHT_NUMBER') }}

    label.mt-4.mb-2.text-uppercase {{ $t('FILTER.ADDRESSES')}}
    acrm-input-line(dark-label v-if="hasRole('orderlist.filters.address')" v-model="model.address").mb-1 {{ $t('FILTER.ADDRESS') }}
    acrm-input-line(dark-label v-if="hasRole('orderlist.filters.address')" v-model="model.destination_address").mb-0 {{ $t('FILTER.RECEIVER') }}

    label.d-block.mt-4.mb-2.text-uppercase {{ $t('FILTER.PROVIDER')}}
    acrm-company-selector.mb-1(type="provider" v-model="model.provider_company_id" dark-label v-if="hasRole('orderlist.filters.provider_company_id')") {{ $t('FILTER.PROVIDER_COMPANY') }}
    acrm-input-user-select.mb-1(v-model="model.provider_user_id" dark-label v-if="hasRole('orderlist.filters.provider_user_id')") {{ $t('FILTER.DRIVER') }}
    acrm-input-car-select.mb-0(v-model="model.car_id" dark-label v-if="hasRole('orderlist.filters.driver_car')") {{ $t('FILTER.CAR_TYPE') }}

    label.d-block.mt-4.mb-2.text-uppercase {{ $t('USERS.PACKETS')}}
    acrm-multi-select(
        :options="packetsExtended"
        multiple
        track-by="id"
        option-label="name"
        v-model="model.packets"
        :allow-empty="true"
        ) {{ $t('ORDERS.LUGGAGE_LIST')}}

    template(v-if="hasRole('orderlist.filters.modifiers') && model.modifier_ids != null")
        label.mt-4.mb-2.c-dark-4 {{ $t('FILTER.MODIFIERS')}}
        acrm-input-switch.mb-2.d-flex.justify-content-between.font-weight-normal(
            dark-label
            v-for="mod in modifiers"
            :key="mod.id"
            v-model="model.modifier_ids[mod.id]"
            ) {{ mod.translated }}
    .separator-top.pt-3.mt-5
    .row.mb-3
        .col-24.col-md-12
            acrm-input-button(block @click="filter").mb-2.mb-md-0 {{ $t('FILTER.FILTER') }}
        .col-24.col-md-12
            acrm-input-button(variant="link" block @click="clear") {{ $t('FILTER.DELETE_FILTER') }}
</template>
